import config from 'favoris-web/config/environment';
import { setBuildURLConfig } from '@warp-drive/utilities/json-api';

export function initialize(): void {
  setBuildURLConfig({
    host: config.favoris.apiHost || null,
    namespace: config.favoris.apiNamespace,
  });
}

export default { initialize };
